import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import Footer from "@/pages/home/components/Footer";

export default function LegalLayout({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 md:h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 shrink-0">
            <img
              src="/assets/images/favicon.webp"
              alt="Mobicar Pro Garage"
              width="512"
              height="512"
              className="h-10 md:h-12 w-auto rounded-md"
            />
            <span className="font-heading text-xl md:text-2xl tracking-wide text-foreground-900">
              MOBICAR PRO
            </span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md text-foreground-700 hover:text-primary-600 hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center" />
            Retour au site
          </Link>
        </div>
      </header>

      <main className="flex-1 py-12 md:py-16">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h1 className="font-heading text-3xl md:text-4xl tracking-wide text-foreground-950 mb-6">
            {title}
          </h1>
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
}